import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-demo-ten',
  templateUrl: './home-demo-ten.component.html',
  styleUrls: ['./home-demo-ten.component.scss']
})
export class HomeDemoTenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
